import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import Autosuggest, { ItemAdapter } from 'react-bootstrap-autosuggest';

class ReportsParameterEmployeeNameAdapter extends ItemAdapter {
    renderItem(item) {
        return (
            <div className="col-md-12 col-lg-12">
                <div>{item.fullName}</div>
            </div>
        );
    }
}

ReportsParameterEmployeeNameAdapter.instance = new ReportsParameterEmployeeNameAdapter();

export default class ReportsParameterEmployeeName extends React.Component {
    constructor() {
        super();

        this.state = {
            selectedEmployee: '',
            employees: null,
            message: ''
        };

        this.onEmployeeSearch = this.onEmployeeSearch.bind(this);
        this.onEmployeeChange = this.onEmployeeChange.bind(this);
        this.onEmployeeSelect = this.onEmployeeSelect.bind(this);
    }

    onEmployeeSearch(search, page, prev) {
        let self = this;

        if (search != '') {
            var url = '';

            if (this.props.role == 'supervisor') {
                url = 'get-people-by-approver';
            }
            else if (this.props.role == 'payroll-admin') {
                url = 'get-people-by-ae';
            }

            if (url != '') {
                ajax.api().get(url, {
                    params: {
                        prefix: search.trim()
                    }
                })
                .then(function (res) {
                    if (res.data.length > 0) {
                        self.setState({
                            employees: res.data,
                            message: ''
                        });
                    }
                    else {
                        self.setState({
                            employees: null,
                            message: 'No matching employees...'
                        });
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                });
            }
        }
        else{
            self.setState({
                employees: null,
                message: 'Type at least one character'
            });
        }
    }
    
    onEmployeeChange(value) {
        value = value.trim();

        this.setState({
            selectedEmployee: value
        });

        if (this.props.onChange)
            this.props.onChange('', value, '');    
    }

    onEmployeeSelect(employee) {
        if (!(typeof employee === 'string' || employee == null) && this.props.onChange)
            this.props.onChange(employee.peopleId, employee.fullName, employee.state);
    }

    render() {
        return (
            <Autosuggest
                datalist={this.state.employees}
                datalistPartial
                datalistMessage={this.state.message}
                placeholder="Select an employee..."
                value={this.state.selectedEmployee}
                itemAdapter={ReportsParameterEmployeeNameAdapter.instance}
                itemValuePropName="fullName"
                searchDebounce={500}
                onSearch={this.onEmployeeSearch}
                onChange={this.onEmployeeChange} 
                onSelect={this.onEmployeeSelect}/>
        );
    }
}